<template>
  <div class="horizontal-progress">
    <div class="pla-spin" :class="[color, size]">
      <div class="pla-spin--bounce1"></div>
      <div class="pla-spin--bounce2"></div>
      <div class="pla-spin--bounce3"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ color: string; size: string }>(), { size: 'S' })
</script>

<style lang="less" scoped>
@import '~@npm/common-styles-lib/lib/color-vars';
@import '~@npm/loading-indicator-lib/lib/processingAnimations';
@import '../styles/vars';

// Create spinner rules for sizes S, M, and L
.createAllSizes(@color) {
  &.S {
    .horizontalSpinner(@color, 0.625rem);
  }
  &.M {
    .horizontalSpinner(@color, 1em);
  }
  &.L {
    .horizontalSpinner(@color, 1.25rem);
  }
}

// pla- = Processing Loading Animation - Namespace for for this component to avoid conflicts with other components
.pla-spin {
  .horizontalSpinner(@c3-e, 0.6em);
}
.midGreen {
  .createAllSizes(@c9-g);
}
.red {
  .createAllSizes(@colorScheme--red);
}
</style>
